import { cva } from 'class-variance-authority'

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-base transition-none disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive cursor-pointer font-bold",
  {
    variants: {
      variant: {
        filter: 'border-2 bg-transparent hover:bg-primary/5',
        outline: 'border-2 bg-transparent hover:bg-primary/5',
        accent:
          'bg-accent text-white hover:bg-[color-mix(in_srgb,var(--color-accent),black_15%)]',
        ghost: '',
        link: 'text-primary underline-offset-4 hover:underline',
        datePicker: 'border border-border rounded-none',
      },
      size: {
        adaptive: 'h-14 md:h-12 px-5', // 56px md: 48px
        xs: 'h-8 px-5', // 32px
        small: 'h-10.5 px-5', // 42x
        medium: 'h-12 px-5', // 48px
        lg: 'h-13 px-5', // 52px
        xl: 'h-14 px-5', // 56px
        '2xl': 'h-15 px-7', // 60px
        '3xl': 'text-lg h-17.5 px-9', // 70px
        filter: 'h-11.5 px-5', // 46px
        datePicker: 'h-12.5 px-2', // 50px
        icon: 'size-9',
        custom: '',
      },
    },
    defaultVariants: {
      variant: 'accent',
      size: 'medium',
    },
  }
)

export { buttonVariants }
